<template>
  <SearchedUserPrimary
    :tenantUser="expert"
    :tenantUserSkills="expert.tenantUserSkills"
  >
    <template v-slot:left-lower-container>
      <div :style="style.container">
        <ButtonTextMuted
          v-if="expert.isTenantTeamTenantUser"
          @click="deleteTenantUserFromTenantTeam(expert)"
        >
          Remove from team
        </ButtonTextMuted>
        <ButtonTextPrimary
          v-else
          @click="addTenantUserToTenantTeam(expert)"
        >
          Add to team
        </ButtonTextPrimary>
      </div>
    </template>
  </SearchedUserPrimary>
</template>

<script>
  import ButtonTextMuted from '@modules/button/button-text-muted'
  import ButtonTextPrimary from '@modules/button/button-text-primary'
  import SearchedUserPrimary from '@modules/search/searched-user-primary'

  export default {
    name: 'SearchedUserHorizontal',
    components: {
      ButtonTextMuted,
      ButtonTextPrimary,
      SearchedUserPrimary,
    },
    props: {
      expert: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          container: {
            display: 'flex',
            height: '64px',
            width: '100%',
          },
        },
      };
    },
    methods: {
      addTenantUserToTenantTeam: function (expert) {
        const tenantUserId = expert.id;
        this.$emit('add-to-team', tenantUserId);
      },
      deleteTenantUserFromTenantTeam: function (expert) {
        this.$emit('delete-from-team', expert.tenantTeamTenantUserId);
      },
    },
  };
</script>
